export default __webpack_public_path__ + "static/media/a011-general2024-example3.6a3e2f9c.png";